import { convertDateFormat } from "utils/dateFormat";

/**
 * Maps a client record (the `clients` API shape) onto the client-profile slice of an
 * admission's `generalInfo`.
 *
 * Single source of truth: the admission's read-only client summary, its completeness
 * banner and the inline "Edit client" dialog all read these keys, so they can no longer
 * drift apart. Returns an empty object when there is no client, which lets callers spread
 * it over admission-derived fallbacks without wiping them.
 */
export const mapClientToProfileFields = (client) => {
  if (!client) return {};

  return {
    clientId: client.id,
    name: client.name,
    address: client.address,
    dob: convertDateFormat(client.dob),
    gender: client.gender,
    email: client.email,
    number: client.number,
    maritalStatus: client.maritalStatus,
    passportNumber: client.passportNumber,
    passportExpiry: convertDateFormat(client.passportExpiry),
    dateOfIssue: convertDateFormat(client.dateOfIssue),
    visaStatus: client.visaStatus,
    visaExpiry: convertDateFormat(client.visaExpiry),
    visaLodged: client.visaLodged,
    usiNumber: client.usiNumber,
    emergencyContactName: client.emergencyContactName ?? client?.emergency?.name,
    emergencyEmail: client.emergencyEmail ?? client?.emergency?.email,
    emergencyContact: client.emergencyContact ?? client?.emergency?.contact,
    emergencyRelation: client.emergencyRelation ?? client?.emergency?.relation,
    emergency: {
      name: client.emergencyContactName,
      email: client.emergencyEmail,
      contact: client.emergencyContact,
      relation: client.emergencyRelation,
    },
    caseOfficer: client.caseOfficer,
    caseOfficerId: client.caseOfficerId,
    // `referral` holds either a user's email or, when `customReferral` is on, a free-text
    // name. `reference` is the legacy alias still read by some admission screens.
    referral: client.referral,
    customReferral: client.customReferral,
    reference: client.referral,
  };
};
